import { handleGetFormDesignWidgetName } from '../render/util';
export const getWidgetTextareaConfig = () => {
    return {
        title: handleGetFormDesignWidgetName,
        icon: 'vxe-icon-textarea',
        query: true,
        options: {
            placeholder: ''
        }
    };
};
